import getWithToken from './base/get-with-token'
import apiGetRequest from './base/api-get-request'

const getCustomersDetail = (id, params = {}) => {
  // If shareCode parameter is provided, use public API without token
  if (params.shareCode) {
    const queryString = new URLSearchParams(params).toString()
    return apiGetRequest(`/customer/${id}?${queryString}`)()
  }
  
  // Otherwise use authenticated API
  return getWithToken(`/customer/${id}`)()
}

export default getCustomersDetail